<template>
  <ColumnWithHelp
    sortable
    :resizable="false"
    :min-width="130"
    :label="label"
    :title="label"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_COST_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { totalInstallCost } }">
      {{ priceFormat(totalInstallCost) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'BidCostColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    priceFormat,
  },
};
</script>
